"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const ButtonContainer_1 = require("../ButtonContainer");
exports.EmailCanvasBlockEnableRichTextButton = ({ usingRichContentEditor, toggle, }) => {
    return (react_1.default.createElement(ButtonContainer_1.ButtonContainer, null,
        react_1.default.createElement(react_2.OsmosysButtonBlockToolbar, { osysName: "EmailCanvasBlockEnableRichTextButton", tooltip: usingRichContentEditor
                ? 'Use regular text box'
                : 'Use rich text editor', className: "text-danger", osysIcon: usingRichContentEditor ? 'toggleOn' : 'toggleOff', 
            // faIcon={usingRichContentEditor ? faToggleOn : faToggleOff}
            onClick: () => {
                toggle();
            } })));
};
//# sourceMappingURL=EnableRichTextButton.js.map